import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TeamSection } from "@/components/site/TeamSection";

export default function Team() {
  return (
    <div data-testid="team-page" className="min-h-screen bg-night text-foreground">
      <header className="border-b border-white/10 bg-night/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="team-brand" className="flex items-center">
            <span className="bg-white rounded-md px-3 py-1.5 flex items-center shadow-md shadow-black/30">
              <img src="/globus-lockup.png" alt="Globus Financial Services" className="h-7 w-auto object-contain" />
            </span>
          </Link>
          <Link data-testid="team-back-link" to="/" className="text-sm text-[#A0AAB2] hover:text-gold transition-colors flex items-center gap-2">
            <ArrowLeft size={14} /> Back to site
          </Link>
        </div>
      </header>
      <main className="pt-8">
        <TeamSection />
      </main>
      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Globus Financial Services · Sahibabad, Uttar Pradesh 201005, India · GSTIN: 09AEFPK4400F1ZW
        </div>
      </footer>
    </div>
  );
}
